module.exports = __webpack_public_path__ + "assets/img/icon_parent_child_pk.f7557125.png";